import { Handle, Position } from '@xyflow/react'
import brokerLogo from '@/assets/hivemq-enterprise-vert.png'
import controlPlaneLogo from '@/assets/control-panel.png'
import { Box, Flex, Text, IconButton, VStack } from '@chakra-ui/react'

const handleStyleTop1 = { left: '25%' }
const handleStyleTop2 = { left: '75%' }
const handleStyleBottom1 = { left: '25%' }
const handleStyleBottom2 = { left: '75%' }

function handleCCClick() {
  window.open(import.meta.env.VITE_CENTRAL_CC_ADDRESS, '_blank', 'noreferrer')
}

interface EntBrokerNodeBiProps {
  data: {
    label?: string
  }
}

function EntBrokerNodeBi({ data }: EntBrokerNodeBiProps) {
  return (
    <Box
      bg="brand.solid"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.700"
      p={3}
      minW="180px"
      boxShadow="md"
    >
      {/* Left/Right handles */}
      <Handle type="target" position={Position.Left} id="left" />
      <Handle type="source" position={Position.Left} id="left" />
      <Handle type="target" position={Position.Right} id="right" />
      <Handle id="c" type="source" position={Position.Right} />

      {/* Top handles */}
      <Handle id="a" type="source" position={Position.Top} style={handleStyleTop1} />
      <Handle id="a" type="target" position={Position.Top} style={handleStyleTop1} />
      <Handle id="b" type="source" position={Position.Top} style={handleStyleTop2} />
      <Handle id="b" type="target" position={Position.Top} style={handleStyleTop2} />

      {/* Bottom handles */}
      <Handle id="d" type="source" position={Position.Bottom} style={handleStyleBottom1} />
      <Handle id="d" type="target" position={Position.Bottom} style={handleStyleBottom1} />
      <Handle id="e" type="source" position={Position.Bottom} style={handleStyleBottom2} />

      <Flex gap={3} align="stretch">
        {/* Left column - Logo and Control Panel */}
        <VStack flex="1" gap={1}>
          <a href={import.meta.env.VITE_CENTRAL_CC_ADDRESS} target="_blank" rel="noreferrer">
            <img
              src={brokerLogo}
              alt="HiveMQ Enterprise"
              style={{ height: '55px', objectFit: 'contain' }}
            />
          </a>
          {data?.label && (
            <Text color="gray.800" fontSize="sm" fontWeight="bold" textAlign="center">
              {data.label}
            </Text>
          )}
          <IconButton
            aria-label="Open Control Center"
            size="xs"
            variant="ghost"
            onClick={handleCCClick}
            _hover={{ bg: 'whiteAlpha.400' }}
          >
            <img
              src={controlPlaneLogo}
              alt="Control Panel"
              style={{ height: '16px', width: '16px' }}
            />
          </IconButton>
        </VStack>

        {/* Right column - Features */}
        <VStack align="end" gap={0.5} flex="none" justify="center">
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Security
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Bridge
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Database
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Streaming
          </Text>
          <Text fontSize="xs" fontWeight="bold" color="gray.800">
            Data Hub
          </Text>
        </VStack>
      </Flex>
    </Box>
  )
}

export default EntBrokerNodeBi
